import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import UIMessageProvider from './components/common/UIMessageProvider';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <UIMessageProvider>
      <App />
    </UIMessageProvider>
  </React.StrictMode>
);